import { GET_SUBJECT } from '../Type';

export const getSubject = () => {
  return {
    type: GET_SUBJECT,
    data: {}
  }
}